import { IJobItemRequest } from '~/types/request/jobItem';
import { SelectOption } from '~/types/common/selectOption';
import { IReportType } from '~/types/models/reportType';
import { IReportTypeResponse } from '~/types/response/reportType';
import { filterReportTypesByAvailability } from '../reportType';

class ReportTypeAdapters {
  public static adaptResponseOne(response: IReportTypeResponse): IReportType {
    return {
      _id: response._id,
      code: response.code,
      default: response.default,
      name: response.name,
      fields: response.fields,
      availableFor: response.availableFor,
    };
  }

  public static adaptResponseAll(response: IReportTypeResponse[]): IReportType[] {
    return response.map(this.adaptResponseOne);
  }

  public static adaptToSelectOptions(
    reportTypes: IReportType[],
    currentJobItem: IJobItemRequest | null,
  ): SelectOption[] {
    return reportTypes
      .filter((reportType) => filterReportTypesByAvailability(reportType, currentJobItem))
      .map(
        (type): SelectOption => ({
          label: type.name,
          value: type.code,
        }),
      );
  }
}

export default ReportTypeAdapters;
